/**
 * Global flag gating the Proposal v2 builder route. Keeps the in-progress
 * builder out of users' way during trunk-based development. Defaults to off;
 * only the literal string "true" enables it.
 */
export const proposalBuilderV2Enabled =
  import.meta.env.VITE_PROPOSAL_BUILDER_V2_ENABLED === 'true';
